import { render, staticRenderFns } from "./WasteDetailsOperations.vue?vue&type=template&id=0efce4eb&"
import script from "./WasteDetailsOperations.vue?vue&type=script&lang=js&"
export * from "./WasteDetailsOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports